export const AVAILABLE_LANGUAGES = [
  { label: "English", code: "en", value: "en" },
  { label: "Español (Also Supports English)", code: "en-es", value: "es" },
  // { label: "Polski (pl-PL)", code: "pl-PL", value: "pl-PL" },
  { label: "Français (fr-FR)", code: "fr-FR", value: "fr-FR" },
  { label: "Русский (ru-RU)", code: "ru-RU", value: "ru-RU" },
  // { label: "English-Spanish (en-US es-PR)", code: "en-es", value: "en-es" },
];
